import { Component, Input } from "@angular/core";
import { ProgressBar } from "../bundles/models.bundle";

@Component({
    selector: "progress-bar",
    template: `
    <div class="progress">
        <div class="progress-bar" role="progressbar" [style.max-width]="item.percentage" [attr.aria-valuenow]="item.value" [attr.aria-valuemin]="item.min" [attr.aria-valuemax]="item.max"></div>
    </div>
    `
})
export class ProgressBarComponent {
    @Input()
    item: ProgressBar;
}